module.exports = __webpack_public_path__ + "static/media/2.1.56cfe8c5.png";